import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_PANEL_WIDTH: createActionType(FULL_NAMESPACE, "SET_PANEL_WIDTH")
};
